import axios from "axios";
import {
	Toast
} from 'vant';
// import {
// 	jsSdk
// } from './api'
import $ from "jquery";
// 线上
export const HERF = 'http://member.vmr.cn/'
export const SOHERF = ''


// import {
//   resolve
// } from "core-js/fn/promise";
const imageCoversion = require("image-conversion");
//上传图片
export function uploadimg(file) {
	const api_token = localStorage.getItem("token");
	const formdata = new FormData();
	console.log(file.file.type, 'type');
	const isJpgOrPng = file.file.type === 'image/jpeg' || file.file.type === 'image/png';
	if (!isJpgOrPng) {
		Toast('上传图片只能是JPG或PNG 格式!');
		return false;
	}
	formdata.append('api_token', api_token)
	return new Promise((resolve, reject) => {
		imageCoversion
			.compressAccurately(file.file, 300)
			.then((res1) => {
				console.log(file.file, '-----------file.file');
				console.log(res1, '-----------res1');
				formdata.append('file', res1)

				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}
				// return new Promise((resolve, reject) => {
				axios.post("/api/uploadImg", formdata, config).then(res => {
					console.log(res.data);
					if (res.data.code == 0) {
						resolve(res.data.data)
					} else {
						Toast(res.data.message)
						resolve(false)
					}
				}).catch(err => {
					Toast(err)
					reject(err)
				})
				// })
			})
			.catch((res) => {
				console.log(res);
				Toast("上传失败，请稍后重试");
			});
	})
}


export function formatRichText(html) { //控制小程序中图片大小
	if (!html) return '';
	return html.replace(/\<img/gi, '<img style="width:100%;height:auto" ');
}

export function getTimer(end_time) {
	let end = new Date(end_time).getTime();
	let now = new Date().getTime();
	let endFont = parseInt((Number(end) - now) / 1000);
	if (endFont > 86400) {
		return parseInt((end - now) / (1000 * 60 * 60 * 24)) + '天';
	} else if (endFont <= 86400 && endFont > 3600) {
		return parseInt((end - now) / (3600 * 1000)) + '小时';
	} else if (endFont < 3600 && endFont > 60) {
		return parseInt((end - now) / (60 * 1000)) + '分钟'
	} else {
		return null;
	}
}

export function getCode() {
	let usercode = getQueryString('usercode');
	// console.log(u1);
	if (usercode) {
		sessionStorage.setItem('userCode', usercode);
		// window.location.href = HERF + '/h5/#/sq'
	}
}
//获取浏览器上的参数
export function getQueryString(variable) {
	let herf = window.location.href;
	let num = herf.indexOf("?") + 1;
	let query = herf.substring(num);
	let vars = query.split("&");
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return false;
}

// 分享配置
import wx from "jweixin-module";
// export function shareJsSdk(shareUrl, shareTitle = '', shareDesc = '', detailId = '', shareImg = '', usercode = '') {
// 	//detailId  --分享人的openid
// 	const u = navigator.userAgent;
// 	let that = this;
// 	const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
// 	let url = "";
// 	if (isiOS) {
// 		url = window.location.href.split("#")[0];
// 		// url = window.location.href;
// 	} else {
// 		url = window.location.href;
// 	}

// 	setTimeout(() => {
// 		jsSdk({
// 			url
// 		}).then((res) => {
// 			wx.config({
// 				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
// 				appId: res.data.appId, // 必填，公众号的唯一标识
// 				timestamp: res.data.timestamp, // 必填，生成签名的时间戳
// 				nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
// 				signature: res.data.signature, // 必填，签名
// 				jsApiList: ["updateAppMessageShareData",
// 					"updateTimelineShareData"
// 				], // 必填，需要使用的JS接口列表
// 			});
// 			let user = localStorage.getItem("user");
// 			if (user) {
// 				user = JSON.parse(user);
// 			} else {
// 				user = "";
// 			}

// 			let u = "#" + window.location.href.split("#")[1];
// 			console.log(detailId, 'detailId')
// 			if (detailId) {
// 				u = HERF + "h5/#/" + shareUrl + "?memberCode=" + detailId + "&share=1";
// 			} else {
// 				u = HERF + "h5/#/" + shareUrl + "?share=1";
// 			}

// 			if (usercode) {
// 				u = u + '&usercode=' + usercode
// 			}

// 			// console.log(u, "-----------shareurl----------");
// 			let title = shareTitle ? shareTitle : ""; //标题
// 			let desc = shareDesc ? shareDesc : ""; //描述文字
// 			// console.log(des, "---------");
// 			wx.ready(function() {
// 				// var myurl = url;
// 				// var myurl = 'http://keyiche.anagelink.cn/h5';
// 				var imgUrl = shareImg ? shareImg : HERF + "img/logo.png";
// 				//分享给朋友
// 				wx.updateAppMessageShareData({
// 					title: title, // 分享标题
// 					desc: desc, // 分享描述
// 					link: u, // 分享链接
// 					imgUrl: imgUrl, // 分享图标
// 					success: function() {
// 						// 用户确认分享后执行的回调函数
// 					},
// 					cancel: function() {
// 						// 用户取消分享后执行的回调函数
// 					},
// 				});
// 				wx.updateTimelineShareData({
// 					title: title, // 分享标题
// 					desc: desc, // 分享描述
// 					link: u, // 分享链接
// 					imgUrl: imgUrl, // 分享图标
// 					success: function() {
// 						// 用户确认分享后执行的回调函数
// 					},
// 					cancel: function() {
// 						// 用户取消分享后执行的回调函数
// 					},
// 				});

// 				wx.error((res) => {
// 					console.log(res);
// 				});
// 				// TODO
// 			});
// 		});
// 	}, 500);
// }


//系统打开的端的类型
export function openType() {
	var ua = navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isChrome = /(?:Chrome|CriOS)/.test(ua),
		isTablet =
		/(?:iPad|PlayBook)/.test(ua) ||
		(isAndroid && !/(?:Mobile)/.test(ua)) ||
		(isFireFox && /(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isPc = !isPhone && !isAndroid && !isSymbian;
	let os = {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc
	};
	if (os.isTablet) {
		// 平板
		return 'pad'
	} else if (os.isAndroid || os.isPhone) {
		// 手机
		return 'mob'
	} else if (os.isPc) {
		// pc
		if (document.body.clientWidth < 768) {
			//小屏
			return 'mob'
		} else {
			//大屏
			return 'pc'
		}
	}
}

export function pcContentHeight(name){
	let offT = $('.container_w_h').offset().top;
	let fixedH =$('#'+name).outerHeight();
	// console.log(fixedH , offT)
	if(fixedH > offT){
		return fixedH - offT
	}else{
		return 10
	}
}